import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";

function GuestInfoForm({ guestInfo, onChange }) {
  const handleChange = (field) => (e) => {
    onChange({ ...guestInfo, [field]: e.target.value });
  };

  return (
    <MKBox component="section" py={4}>
      <Container maxWidth="sm">
        <MKTypography variant="h5" mb={3}>
          Guest Information
        </MKTypography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MKInput
              label="Full Name"
              fullWidth
              value={guestInfo.name}
              onChange={handleChange("name")}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <MKInput
              type="email"
              label="Email Address"
              fullWidth
              value={guestInfo.email}
              onChange={handleChange("email")}
              required
            />
          </Grid>
          <Grid item xs={4} md={2}>
            <MKInput
              label="Area Code"
              fullWidth
              value={guestInfo.countryCode}
              onChange={handleChange("countryCode")}
              placeholder="+1"
              required
            />
          </Grid>
          <Grid item xs={8} md={4}>
            <MKInput
              type="tel"
              label="Phone Number"
              fullWidth
              value={guestInfo.phone}
              onChange={handleChange("phone")}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <MKInput
              type="number"
              label="Children (included in total)"
              fullWidth
              value={guestInfo.children}
              onChange={handleChange("children")}
              inputProps={{ min: 0 }}
            />
          </Grid>
          <Grid item xs={12}>
            <MKInput
              label="Additional Info (optional)"
              multiline
              rows={3}
              fullWidth
              value={guestInfo.specialRequests}
              onChange={handleChange("specialRequests")}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

GuestInfoForm.propTypes = {
  guestInfo: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    countryCode: PropTypes.string,
    phone: PropTypes.string,
    children: PropTypes.string,
    specialRequests: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default GuestInfoForm;
